import {Component, OnInit} from '@angular/core';
import {environment} from '../../../environments/environment';
import {GetSetDataService} from '../../services/get-set-data.service';
import {SingleForumSmallViewComponent} from '../single-forum-small-view/single-forum-small-view.component';
import {SearchPipe} from '../pipes/search-pipe.pipe';
import {LoaderComponent} from '../loader/loader.component';
import {NgForOf, NgIf} from '@angular/common';

@Component({
  selector: 'app-right-view',
  templateUrl: './right-view.component.html',
  imports: [
    SingleForumSmallViewComponent,
    SearchPipe,
    LoaderComponent,
    NgIf,
    NgForOf
  ],
  styleUrls: ['./right-view.component.scss']
})
export class RightViewComponent implements OnInit {

  public dataBlogPosts: any = [];
  public searchQuery = '';
  public isPostsNotLoaded = true;

  public loginURL = environment.LOGIN_URL;

  constructor(private getSetData: GetSetDataService) {
  }

  async ngOnInit() {
    this.dataBlogPosts = await this.getSetData.getBlogPosts();

    this.isPostsNotLoaded = false;

    this.getSetData.EmitterSearch.subscribe((searchQuery: string) => {
      this.searchQuery = searchQuery;
    });
  }

}
